import { Outlet, useParams } from "react-router";
import { useAuth } from "@/auth/AuthContext";
import { TabNav } from "@/components/TabNav";

const tabs = [
  { label: "Identity provider", to: "sso" },
  { label: "Host identity", to: "host-identity" },
  { label: "Encryption", to: "encryption" },
  { label: "Log streaming", to: "log-streaming" },
];

export function SettingsLayout() {
  const { orgId } = useParams();
  const { user } = useAuth();

  return (
    <div className="mx-auto max-w-3xl text-foreground">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="mt-0.5 text-sm text-foreground/70">
          Configuration for the {user?.orgName} organization
        </p>
      </div>

      <TabNav tabs={tabs} basePath={`/${orgId}/settings`} />

      <Outlet />
    </div>
  );
}
